/**
 * @typedef {import('../../shared/index.d.ts').OnConsentChangeListener} OnConsentChangeListener
 * @typedef {import('../../shared/index.d.ts').DodoUserAgentConsentApi} DodoUserAgentConsentApi
 */
/* eslint-disable class-methods-use-this */
/**
 * @implements {DodoUserAgentConsentApi}
 */
export class DodoConsent {
  /**
   * @type {Set<OnConsentChangeListener>}
   * @private
   */
  #consentListeners;

  constructor() {
    this.#consentListeners = new Set();
    this.#attachListener();
  }

  #attachListener() {
    window.BoschPrivacyCallback_OnUpdate = (consents) => {
      this.#consentListeners.forEach((cb) => {
        try {
          cb(consents);
        } catch (error) {
          console.error('Consent listener threw', error);
        }
      });
    };
  }

  getData() {
    const dock = document.querySelector('ebds-consent-prompt dock-privacy-settings');

    if (!(dock && typeof dock === 'object')) {
      throw new Error('No DOCK found');
    }
    // @ts-ignore
    return dock.consents;
  }

  /**
   *
   * @param {OnConsentChangeListener} cb
   */
  addListener(cb) {
    this.#consentListeners.add(cb);
  }

  /**
   *
   * @param {OnConsentChangeListener} cb
   */
  removeListener(cb) {
    this.#consentListeners.delete(cb);
  }
}
